import {NatGetCurrentDateTime} from './NatGetCurrentDateTime'
import Http from '../../../../network/Http'

export default class NatCurrentDateTimeRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 現在日時取得
    async getCurrentDateTime(): Promise<NatGetCurrentDateTime> {
        return await this.http.get(`/api/common/currentDateTime`);
    }
}
